import { Component } from 'react'
import PropTypes from 'prop-types'
import Button from 'observian-ui/lib/button'
import ContactModal from 'observian-ui/lib/modal/contact'
import { buildFormUrl } from '../../../../utils/formRedirect'

import GoogleForm from 'components/Form'
import CertCount from 'components/SVG/certificationCount'

import style from './certifications.module.css'

class Certifications extends Component {
  state = {
    showModal: false,
    isSuccessful: false,
  }

  handleModal = () => {
    this.setState((state) => ({
      showModal: !state.showModal,
    }))
  }

  handleIsSuccessful = (value) => {
    this.setState({ isSuccessful: value })
  }

  render() {
    const { showModal, isSuccessful } = this.state
    const { formId } = this.props

    return (
      <section className={style.section}>
        <svg
          className={style.topDivider}
          xmlns="http://www.w3.org/2000/svg"
          width="1463"
          height="175"
          viewBox="0 0 1463 175"
        >
          <polygon fill="#FFF" fillRule="evenodd" points="0 174.5 0 0 1462.5 0 1069 97 288 113.5" />
        </svg>
        <svg
          className={style.topDividerLong}
          xmlns="http://www.w3.org/2000/svg"
          width="2104"
          height="175"
          viewBox="0 0 2104 175"
        >
          <g fill="#FFF" fillRule="evenodd">
            <polygon points="641.5 174.5 641.5 0 2104 0 1710.5 97 929.5 113.5" />
            <polygon points="642 0 0 0 642 174.5" />
          </g>
        </svg>
        <div className={style.sectionContainer}>
          <div className={style.container}>
            <div className={style.content}>
              <svg
                className={style.gcpParticles}
                xmlns="http://www.w3.org/2000/svg"
                width="632"
                height="215"
                viewBox="0 0 632 215"
              >
                <defs>
                  <linearGradient
                    id="google-particles-a"
                    x1="12.453%"
                    x2="87.895%"
                    y1="71.704%"
                    y2="29.075%"
                  >
                    <stop offset="0%" stopColor="#1D8DBA" />
                    <stop offset="100%" stopColor="#03ECAE" />
                  </linearGradient>
                  <linearGradient
                    id="google-particles-b"
                    x1="12.453%"
                    x2="87.895%"
                    y1="71.704%"
                    y2="29.075%"
                  >
                    <stop offset="0%" stopColor="#1D8DBA" />
                    <stop offset="100%" stopColor="#03ECAE" />
                  </linearGradient>
                  <linearGradient
                    id="google-particles-c"
                    x1="12.453%"
                    x2="87.895%"
                    y1="73.653%"
                    y2="27.196%"
                  >
                    <stop offset="0%" stopColor="#1D8DBA" />
                    <stop offset="100%" stopColor="#03ECAE" />
                  </linearGradient>
                </defs>
                <g fill="none" fillRule="evenodd" opacity=".145">
                  <polygon
                    fill="#DCE1E0"
                    points="0 215.038 81.484 46.91 261.074 12.339 89.383 57.05"
                    opacity=".5"
                  />
                  <polygon
                    fill="url(#google-particles-a)"
                    stroke="url(#google-particles-a)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    points="111.405 143.42 120.367 157.551 102.443 157.551"
                    transform="rotate(-13 111.405 150.485)"
                  />
                  <polygon
                    fill="url(#google-particles-b)"
                    stroke="url(#google-particles-b)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    points="620.472 120.306 631.547 137.767 609.397 137.767"
                    transform="rotate(-95 620.472 129.037)"
                  />
                  <polygon
                    fill="url(#google-particles-c)"
                    stroke="url(#google-particles-c)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    points="349.068 2 354.41 10.793 343.725 10.793"
                    transform="rotate(-26 349.068 6.397)"
                  />
                </g>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="311" height="37" viewBox="0 0 311 37">
                <defs>
                  <linearGradient
                    id="freeworkshops-a"
                    x1="12.453%"
                    x2="87.895%"
                    y1="50.48%"
                    y2="49.537%"
                  >
                    <stop offset="0%" stopColor="#1D8DBA" />
                    <stop offset="100%" stopColor="#03ECAE" />
                  </linearGradient>
                </defs>
                <path
                  fill="url(#freeworkshops-a)"
                  d="M13.8,18.24 L6.84,18.24 L6.84,28.92 L0,28.92 L0,0.92 L14.8,0.92 L14.8,7.04 L6.84,7.04 L6.84,12.16 L13.8,12.16 L13.8,18.24 Z M31.52381,7.4 L31.52381,14.2 C31.24381,14.16 30.92381,14.12 30.44381,14.12 C27.20381,14.12 26.12381,16.48 26.12381,19.64 L26.12381,28.92 L19.44381,28.92 L19.44381,7.92 L25.96381,7.92 L25.96381,10.72 C26.96381,8.68 28.92381,7.4 31.52381,7.4 Z M54.48762,20.16 L40.72762,20.16 C40.88762,22.04 42.68762,23.64 45.16762,23.64 C47.68762,23.64 49.16762,22 49.56762,21.4 L53.96762,24.8 C53.36762,26.04 50.48762,29.44 45.04762,29.44 C38.12762,29.44 33.88762,24.68 33.88762,18.48 C33.88762,12.32 38.04762,7.4 44.20762,7.4 C50.88762,7.4 54.52762,11.68 54.52762,18.84 C54.52762,19.24 54.52762,19.68 54.48762,20.16 Z M44.32762,12.8 C42.12762,12.8 41.08762,14.44 40.92762,15.92 L47.72762,15.92 C47.64762,14.24 46.40762,12.8 44.32762,12.8 Z M78.29143,20.16 L64.53143,20.16 C64.69143,22.04 66.49143,23.64 68.97143,23.64 C71.49143,23.64 72.97143,22 73.37143,21.4 L77.77143,24.8 C77.17143,26.04 74.29143,29.44 68.85143,29.44 C61.93143,29.44 57.69143,24.68 57.69143,18.48 C57.69143,12.32 61.85143,7.4 68.01143,7.4 C74.69143,7.4 78.33143,11.68 78.33143,18.84 C78.33143,19.24 78.33143,19.68 78.29143,20.16 Z M68.13143,12.8 C65.93143,12.8 64.89143,14.44 64.73143,15.92 L71.53143,15.92 C71.45143,14.24 70.21143,12.8 68.13143,12.8 Z M114.37905,28.92 L109.85905,11.32 L105.33905,28.92 L97.57905,28.92 L90.29905,0.92 L97.61905,0.92 L101.85905,20.64 L106.77905,0.92 L112.93905,0.92 L117.85905,20.64 L122.09905,0.92 L129.41905,0.92 L122.13905,28.92 L114.37905,28.92 Z M131.50286,18.48 C131.50286,12.12 136.42286,7.4 142.90286,7.4 C149.66286,7.4 154.42286,12.04 154.42286,18.4 C154.42286,24.72 149.54286,29.44 142.90286,29.44 C136.22286,29.44 131.50286,24.8 131.50286,18.48 Z M138.18286,18.48 C138.18286,21.52 140.18286,23.56 142.90286,23.56 C145.66286,23.56 147.74286,21.4 147.74286,18.4 C147.74286,15.32 145.62286,13.28 142.90286,13.28 C140.14286,13.28 138.18286,15.4 138.18286,18.48 Z M170.78667,7.4 L170.78667,14.2 C170.50667,14.16 170.18667,14.12 169.70667,14.12 C166.46667,14.12 165.38667,16.48 165.38667,19.64 L165.38667,28.92 L158.70667,28.92 L158.70667,7.92 L165.22667,7.92 L165.22667,10.72 C166.22667,8.68 168.18667,7.4 170.78667,7.4 Z M194.83048,7.92 L188.07048,17.52 L195.39048,28.92 L187.55048,28.92 L181.67048,19.12 L181.67048,28.92 L174.99048,28.92 L174.99048,0 L181.67048,0 L181.67048,16.36 L187.35048,7.92 L194.83048,7.92 Z M205.59429,29.44 C201.59429,29.44 198.75429,27.52 197.51429,25.84 L201.27429,22.2 C202.39429,23.2 203.79429,24.04 205.91429,24.04 C207.19429,24.04 207.79429,23.64 207.79429,22.88 C207.79429,20.48 198.19429,21.52 198.19429,13.88 C198.19429,9.84 201.71429,7.4 206.27429,7.4 C210.27429,7.4 212.55429,9.32 213.79429,11 L209.47429,14.4 C208.83429,13.76 207.63429,12.76 205.99429,12.76 C205.03429,12.76 204.47429,13.16 204.47429,13.8 C204.47429,16.44 214.15429,14.92 214.15429,22.52 C214.15429,26.8 210.39429,29.44 205.59429,29.44 Z M230.5581,28.92 L230.5581,16.4 C230.5581,14.44 229.3981,13.4 227.7981,13.4 C225.9581,13.4 224.8381,14.72 224.8381,16.4 L224.8381,28.92 L218.1581,28.92 L218.1581,0 L224.8381,0 L224.8381,10.08 C225.6381,8.84 227.3981,7.4 230.0381,7.4 C236.5981,7.4 237.2381,13 237.2381,17.28 L237.2381,28.92 L230.5581,28.92 Z M241.36191,18.48 C241.36191,12.12 246.28191,7.4 252.76191,7.4 C259.52191,7.4 264.28191,12.04 264.28191,18.4 C264.28191,24.72 259.40191,29.44 252.76191,29.44 C246.08191,29.44 241.36191,24.8 241.36191,18.48 Z M248.04191,18.48 C248.04191,21.52 250.04191,23.56 252.76191,23.56 C255.52191,23.56 257.60191,21.4 257.60191,18.4 C257.60191,15.32 255.48191,13.28 252.76191,13.28 C250.00191,13.28 248.04191,15.4 248.04191,18.48 Z M275.04572,18.36 C275.04572,21.68 276.92572,23.56 279.56572,23.56 C282.28572,23.56 284.08572,21.44 284.08572,18.36 C284.08572,15.24 282.24572,13.24 279.56572,13.24 C276.68572,13.24 275.04572,15.56 275.04572,18.36 Z M274.80572,7.92 L274.80572,9.56 C275.40572,8.88 277.40572,7.4 280.48572,7.4 C286.52572,7.4 290.76572,11.96 290.76572,18.4 C290.76572,24.92 286.92572,29.44 280.84572,29.44 C277.64572,29.44 275.68572,27.84 275.24572,27.32 L275.24572,36.4 L268.56572,36.4 L268.56572,7.92 L274.80572,7.92 Z M301.80953,29.44 C297.80953,29.44 294.96953,27.52 293.72953,25.84 L297.48953,22.2 C298.60953,23.2 300.00953,24.04 302.12953,24.04 C303.40953,24.04 304.00953,23.64 304.00953,22.88 C304.00953,20.48 294.40953,21.52 294.40953,13.88 C294.40953,9.84 297.92953,7.4 302.48953,7.4 C306.48953,7.4 308.76953,9.32 310.00953,11 L305.68953,14.4 C305.04953,13.76 303.84953,12.76 302.20953,12.76 C301.24953,12.76 300.68953,13.16 300.68953,13.8 C300.68953,16.44 310.36953,14.92 310.36953,22.52 C310.36953,26.8 306.60953,29.44 301.80953,29.44 Z"
                />
              </svg>
              <h2 className={style.title}>from Certified Experts</h2>
              <p className={style.description}>
                Observian will come on site or host your team to train your staff on how to best
                utilize Google Cloud Platform. Our team of certified GCP experts will help guide you
                on topics from container orchestration with kubernetes to machine learning. Sessions
                fill up fast, so book soon!
              </p>
              <Button
                label="Schedule a Workshop"
                className={style.button}
                onClick={() => window.location.href = buildFormUrl([
                  {
                    key: 'CTA',
                    value: 'Google Cloud - Schedule a Workshop'
                  }
                ])}
              />
              {showModal ? (
                <ContactModal
                  showClose
                  shouldCloseOnOverlayClick
                  onClose={this.handleModal}
                  onDismiss={this.handleModal}
                  isOpen={showModal}
                  closeButtonPosition="right"
                  ariaHideApp={false}
                  success={isSuccessful}
                >
                  <GoogleForm
                    showLogo
                    showContactInfo
                    isGoogleForm
                    formId={formId}
                    headerTitle="Contact Us"
                    buttonLabel="Send"
                    ctaIntentSuffix="modal-google-certified-workshops"
                    inquiryPlaceholder="I am interested in working with Observian as a Google Partner to help train my team on Google Cloud services."
                    isSuccessfulCallback={(v) => {
                      this.handleSetSuccessful(v)
                      if (!v) {
                        this.handleModal
                      }
                    }}
                  />
                </ContactModal>
              ) : null}
            </div>
            <div className={style.certs}>
              <CertCount
                type="gcp"
                className={style.cert}
                count={11}
                title="Certified Cloud Experts"
              />
            </div>
          </div>
        </div>
        <svg
          className={style.bottomLaser}
          xmlns="http://www.w3.org/2000/svg"
          width="858"
          height="91"
          viewBox="0 0 858 91"
        >
          <defs>
            <linearGradient
              id="google-laser-divider-a"
              x1="7.122%"
              x2="46.66%"
              y1="50.696%"
              y2="51.341%"
            >
              <stop offset="0%" stopColor="#3065BB" />
              <stop offset="100%" stopColor="#5A99FF" />
            </linearGradient>
            <linearGradient
              id="google-laser-divider-b"
              x1="12.453%"
              x2="87.895%"
              y1="50.641%"
              y2="49.382%"
            >
              <stop offset="0%" stopColor="#F90" />
              <stop offset="100%" stopColor="#FFC671" />
            </linearGradient>
          </defs>
          <g fill="none" fillRule="evenodd">
            <polygon
              fill="url(#google-laser-divider-a)"
              points="0 23.277 229.962 90.516 410.58 56.896 229.962 72.445"
            />
            <polygon
              fill="url(#google-laser-divider-b)"
              points="334.216 71.02 571.779 50.66 858.365 0 565.673 36.393 410.58 56.896"
            />
          </g>
        </svg>

        <svg
          className={style.bottomDivider}
          xmlns="http://www.w3.org/2000/svg"
          width="1562"
          height="148"
          viewBox="0 0 1562 148"
        >
          <polygon fill="#FFF" fillRule="evenodd" points="0 35 0 148 1562 148 1562 0 434.5 96" />
        </svg>
        <svg
          className={style.bottomDividerLong}
          xmlns="http://www.w3.org/2000/svg"
          width="3035"
          height="148"
          viewBox="0 0 3035 148"
        >
          <g fill="#FFF" fillRule="evenodd">
            <polygon points="713 35 713 148 2275 148 2275 0 1147.5 96" />
            <polygon points="2274 148 3035 148 2274 0" />
            <polygon points="715 148 0 148 715 35" />
          </g>
        </svg>
      </section>
    )
  }
}

Certifications.propTypes = {
  formId: PropTypes.string.isRequired,
}

export default Certifications
